import { useModal } from "~/lib/hooks/useModal";
export const menuModalName = "mobile-menu";
export const useMenuModal = () => {
	const { isOpen, openModal, closeModal, toggleModal } = useModal(menuModalName, () => {});

	return {
		isOpen,
		openModal,
		closeModal,
		toggleModal,
	};
};
